import { render, staticRenderFns } from "./MessageTemplateInfoPanel.vue?vue&type=template&id=b6074ad0&scoped=true&"
import script from "./MessageTemplateInfoPanel.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateInfoPanel.vue?vue&type=style&index=0&id=b6074ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6074ad0",
  null
  
)

export default component.exports